import React from 'react';
import { Box, Snackbar, Typography } from '@mui/material';
import { Icon } from '@iconify/react';

const toastConfig = {
  success: {
    backgroundColor: '#B6FFC3',
    textColor: '#004D40',
    iconColor: '#00AD5E',
    icon: 'solar:check-circle-bold',
  },
  error: {
    backgroundColor: '#FDEDED',
    textColor: '#DA342E',
    iconColor: '#DA342E',
    icon: 'solar:close-circle-bold',
  },
};

export default function AlertToast({ open, onClose, message, variant = 'success' }) {
  const config = toastConfig[variant] || toastConfig.success;

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          bgcolor: config.backgroundColor,
          py: 1.5,
          px: 4.5,
          borderRadius: '30px',
          boxShadow: 3,
          maxWidth: { xs: 'calc(100vw - 24px)', sm: 400 },
          width: 'fit-content',
          mr: 0,
        }}
      >
        <Icon icon={config.icon} width="24" height="24" color={config.iconColor} />
        <Typography
          sx={{
            color: config.textColor,
            fontWeight: 600,
            fontSize: '0.95rem',
            flexGrow: 1,
            ml: 1.5,
          }}
        >
          {message}
        </Typography>
      </Box>
    </Snackbar>
  );
}
